var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSnapchatMobileMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 5,
  height: 18,
  viewBox: "0 0 5 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.25 13.5a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5m0-7a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5m0-6.5a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5"
})));
export default SvgSnapchatMobileMore;